export type FileTypeKey =
  | '3ds'
  | 'catia'
  | 'creo'
  | 'gltf'
  | 'inventor'
  | 'iges'
  | 'parasolid'
  | 'solidedge'
  | 'solidworks'
  | 'step'
  | 'stl'
  | 'obj'
  | 'jt'
  | 'images'
  | 'documents';

export type FileTypeInfo = {
  readonly format: string;
  readonly extensions: readonly string[];
  readonly version: string;
};

export const FILE_TYPE_MAP: Record<FileTypeKey, FileTypeInfo> = {
  '3ds': { format: 'Autodesk 3DS', extensions: ['.3ds'], version: 'Any' },
  catia: { format: 'Catia V5', extensions: ['.catpart', '.catproduct'], version: 'Up to V5_6R2023' },
  creo: { format: 'Creo', extensions: ['.prt', '.asm'], version: 'Pro/E 19 to Wildfire 5.0\nCreo 1.0-10.0' },
  gltf: { format: 'glTF', extensions: ['.glb'], version: '2.0' },
  inventor: { format: 'Autodesk Inventor', extensions: ['.iam', '.ipt'], version: 'Up to 2024' },
  iges: { format: 'IGES', extensions: ['.igs', '.iges'], version: '5.1, 5.2, 5.3' },
  parasolid: { format: 'Parasolid', extensions: ['.x_b', '.x_t'], version: 'Up to 35.1' },
  solidedge: { format: 'Solid Edge', extensions: ['.asm', '.par'], version: '1 to 20\nST1 to ST10\n2019 to 2023' },
  solidworks: { format: 'SolidWorks', extensions: ['.sldasm', '.sldprt'], version: '97 to 2023' },
  step: { format: 'STEP', extensions: ['.step', '.stp'], version: 'AP203\nAP214\nAP242' },
  stl: { format: 'STL', extensions: ['.stl'], version: 'Any' },
  obj: { format: 'OBJ', extensions: ['.obj'], version: 'Any' },
  jt: { format: 'JT', extensions: ['.jt'], version: '8, 9, 10' },
  images: { format: 'Images', extensions: ['.gif', '.jpeg', '.jpg', '.png'], version: 'Any' },
  documents: { format: 'Documents', extensions: ['.pdf', '.txt'], version: 'Any' },
} as const;
